import React from 'react';
import { palette } from '../../style-utils/theme';

interface ParcelIconProps {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  stroke?: string;
}

/**
 * A box with tape down the middle.
 *
 * The desk menu had no parcel glyph, so "Parcel in" and "Parcel out" borrowed
 * the VISITOR icon — a person. On a screen whose whole point is that a tile can
 * be recognised without reading it, three different errands wearing the same
 * face is the part that stops working first.
 *
 * Same drawing conventions as the icons beside it: 24×24, 1px stroke in
 * palette.slate, round caps, no fill.
 */
/* DECORATION. This glyph always sits beside its own text label, so
   exposing it to the accessibility tree only adds a nameless graphic
   before every button that uses it. */
export const ParcelIcon: React.FC<ParcelIconProps> = ({ onClick, stroke }) => {
  const color = stroke || palette.slate;

  return (
    <svg
      aria-hidden="true"
      focusable="false"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path
        d="M3.5 7.5L12 3.5L20.5 7.5V16.5L12 20.5L3.5 16.5V7.5Z"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M3.5 7.5L12 11.5L20.5 7.5" stroke={color} strokeLinejoin="round" />
      <path d="M12 11.5V20.5" stroke={color} strokeLinecap="round" />
      <path d="M7.75 5.5L16.25 9.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};
